import React, { useEffect, useState } from "react";
import { ReactComponent as TrashIcon } from "../../../../../../assets/dashboard/link/trashIcon.svg";
import { ReactComponent as TrashIconDark } from "../../../../../../assets/dashboard/link/trashIcon-dark.svg";

import ExtraSmallFilledButton from "../../../../../../components/common/buttons/ExtraSmallFilledButton";
import LocationIcon from "../../../../../../assets/map/location.svg";
import LocationIconDark from "../../../../../../assets/map/location-dark.svg";
import { useLocationContext } from "../../../../../../contexts/LocationContext";
import useLocales from "../../../../../../hooks/useLocales";
import ContactIcon from "../../../../../../assets/MainPage/addBlock/countDown/call.svg";
import ContactIconDark from "../../../../../../assets/MainPage/addBlock/countDown/call-dark.svg";
import { ReactComponent as DownArrow } from "../../../../../../assets/settingPage/arrow-down.svg";
import { ReactComponent as MapPin } from "../../../../../../assets/map/MapPin.svg";
import { ReactComponent as MapPinDark } from "../../../../../../assets/map/MapPin_Dark.svg";
import { ReactComponent as Phone } from "../../../../../../assets/map/Phone.svg";
import { ReactComponent as PhoneDark } from "../../../../../../assets/map/Phone_Dark.svg";

import useSettings from "../../../../../../hooks/useSettings";
import httpRequest from "../../../../../../axios/index";
import {
  setShowForm,
  setShowLocationData,
} from "../../../../../../redux/slices/location/locationSlice";

import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import i18nForComponent from "../../../../../../locales/component/i18nForComponent";
import { I18nextProvider } from "react-i18next";

const inputErrorClasses =
  "border-state_color_error placeholder:text-state_color_error";
const inputNoErrorClasses =
  "border-light_bg_v2 focus:placeholder:text-heading_color focus:border-font_light_color";

const AddLocationForm = ({
  getLocationMapData,
  currentAddress,
  setCurrentAddress,
}) => {
  const { darkMode } = useSelector((state) => state.theme);
  const dispatch = useDispatch();

  const { allLangs, tComponent, handleLanguageChange } = useLocales();
  const { locations, setLocations } = useLocationContext();

  const { themeDirection } = useSettings();
  const [isMainDefault, setIsMainDefault] = useState(false);
  const navigate = useNavigate();

  const [selectReporterTypeDropDown, setSelectReporterTypeDropDown] =
    useState(false);
  const [selectedReporterType, setSelectedReporterType] = useState("English");
  const [selectedLang, setSelectedLang] = useState("en");

  useEffect(() => {
    if (selectedLang) {
      handleLanguageChange(selectedLang);
    }
  }, [selectedLang]);

  // useEffect(() => {
  //   if (currentAddress) {
  //     setValue("address", currentAddress);
  //   }
  // }, [currentAddress]);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const geocodeAddress = async (address) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
          address
        )}`
      );
      const data = await response.json();
      if (data.length > 0) {
        const lat = parseFloat(data[0].lat);
        const lon = parseFloat(data[0].lon);
        const directionUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lon}`;
        return { lat, lon, directionUrl };
      } else {
        toast.error("Address not found, please try again");
        return {};
      }
    } catch (error) {
      console.error("Error geocoding address:", error);
      toast.error("Error while fetching address data");
      return {};
    }
  };

  const SubmitHandler = async (data) => {
    const { userid } = JSON.parse(localStorage.getItem("user"));
    const linkid = localStorage.getItem("linkId");
    try {
      let locationData = {};
      if (data?.address) {
        locationData = await geocodeAddress(data?.address);
        if (!locationData.lat || !locationData.lon) {
          toast.error("Please enter a correct address");
          return;
        }
      } else {
        locationData = { lat: data?.lat, lon: data?.lon };
      }

      const payload = {
        coloum_name: "mapData",
        coloum_type: "mapData",
        link_id: linkid,
        userId: userid,
        title: data?.title,
        address: data?.address,
        phone: data?.phone,
        lat: locationData.lat,
        lon: locationData.lon,
        directionUrl: locationData.directionUrl,
        isPrimary: isMainDefault,
        language: selectedLang,
      };
      // const newLocation = { ...data, ...locationData }
      // setLocations([...locations, newLocation])
      // handleAddLocation({ ...data, ...locationData })
      const url = "/api/user/createLocationBlock";
      // const url = '/api/user/maps'
      const response = await httpRequest.post(url, payload);
      const result = response?.data?.message;
      const status = response?.data?.status;
      if (status === "success") {
        toast.success(result);
        reset();
        setCurrentAddress(null);
        // navigate('/dashboard/component/locationList')
        dispatch(setShowForm(false));
        dispatch(setShowLocationData(true));
        getLocationMapData();
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Something went wrong");
    }
  };

  const handleChangeLang = (newLang) => {
    handleLanguageChange(newLang);
  };

  return (
    <I18nextProvider i18n={i18nForComponent}>
      <div
        className="relative mt-2"
        style={{
          direction: selectedLang === "ar" ? "rtl" : "ltr",
        }}
      >
        <form
          onSubmit={handleSubmit((data) => SubmitHandler(data))}
          className=" mt-4 bg-white dark:bg-dark-secondary p-6 border border-gray-300 rounded mt-2"
        >
          <div className="flex justify-between items-center mb-[20px] sm:mb-[25px]">
            <p className="text-small2_b sm:text-small1_bold text-heading_color dark:text-color_v1_dark uppercase">
              {tComponent("location.add_location")}
            </p>
            <div className="flex items-center justify-center">
              <div className="relative w-[115px] sm:w-[145px]">
                <div
                  onClick={() => {
                    setSelectReporterTypeDropDown(!selectReporterTypeDropDown);
                  }}
                  className={`bg-light_bg_v4 capitalize p-[13px] text-small2 lg:text-body_copy2 rounded-md w-full flex justify-between items-center cursor-pointer`}
                >
                  {selectedReporterType
                    ? selectedReporterType
                    : tComponent("location.select_lang")}
                  <DownArrow />
                </div>
                {selectReporterTypeDropDown && (
                  <div className="absolute top-14 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5  rounded-lg border flex flex-col max-h-40 overflow-y-auto">
                    {allLangs?.map((item, i) => {
                      return (
                        <div
                          key={i}
                          onClick={() => {
                            setSelectedLang(item.value); // Set selected language code
                            setSelectedReporterType(item?.label);
                            setSelectReporterTypeDropDown(false);
                            handleChangeLang(item?.value);
                          }}
                          className="px-[10px] md:px-[15px] py-[7px] md:py-[10px] capitalize text-small2 lg:text-body_copy2 text-heading_color cursor-pointer hover:bg-light_bg_v4 rounded-md"
                        >
                          {item.label}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div>
            <label
              className="text-small2_b sm:text-small1_bold  text-heading_color dark:text-color_v1_dark uppercase"
              htmlFor="title"
            >
              {tComponent("location.adress_title_caps")}
            </label>
            <div className="flex flex-col lg:flex-row w-full">
              <div className="mt-4">
                <div>
                  <div className="relative">
                    <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex justify-center items-center">
                      {darkMode ? <MapPinDark /> : <MapPin />}
                    </div>
                    <input
                      type="text"
                      id="title"
                      name="title"
                      {...register("title", {
                        required: "Title is required",
                      })}
                      className={`rounded-md border bg-light_bg_v5 p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] text-heading_color text-small2 sm:text-small1 focus:outline-none focus:ring-0 focus:placeholder:text-heading_color block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                        errors.title
                          ? "border-state_color_error dark:bg-dark-secondary"
                          : "border-light_bg_v2 focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                      }`}
                      placeholder={tComponent("location.enter_location_name")}
                    />
                  </div>
                  {errors?.title && (
                    <small className="text-state_color_error text-small3">
                      {errors?.title?.message}
                    </small>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="mt-4">
            <label
              className="text-small2_b sm:text-small1_bold  text-heading_color dark:text-color_v1_dark uppercase"
              htmlFor="address"
            >
              {tComponent("location.adress_details_caps")}
            </label>
            <div className="flex flex-col lg:flex-row mt-4 w-full gap-2 mt-2">
              <div>
                <div className="relative">
                  <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex justify-center items-center">
                    {darkMode ? <MapPinDark /> : <MapPin />}
                  </div>
                  <input
                    type="text"
                    id="address"
                    name="address"
                    {...register("address", {
                      required: "Address is required",
                    })}
                    className={`rounded-md border bg-light_bg_v5 p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] text-heading_color text-small2 sm:text-small1 focus:outline-none focus:ring-0 focus:placeholder:text-heading_color block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                      errors.address
                        ? "border-state_color_error dark:bg-dark-secondary"
                        : "border-light_bg_v2 focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                    }`}
                    placeholder={tComponent("location.enter_location_adress")}
                  />
                </div>
                {errors?.address && (
                  <small className="text-state_color_error text-small3">
                    {errors?.address?.message}
                  </small>
                )}
              </div>

              <div>
                <div className="relative">
                  <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex justify-center items-center">
                    {darkMode ? <PhoneDark /> : <Phone />}
                  </div>
                  <input
                    type="number"
                    id="phone"
                    name="phone"
                    {...register("phone", {
                      required: "Phone is required",
                    })}
                    className={`rounded-md border bg-light_bg_v5 p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] text-heading_color text-small2 sm:text-small1 focus:outline-none focus:ring-0 focus:placeholder:text-heading_color block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                      errors.phone
                        ? "border-state_color_error dark:bg-dark-secondary"
                        : "border-light_bg_v2 focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                    }`}
                    placeholder={tComponent("location.enter_location_phone")}
                  />
                </div>
                {errors?.phone && (
                  <small className="text-state_color_error text-small3">
                    {errors?.phone?.message}
                  </small>
                )}
              </div>
            </div>
          </div>

          <label className="flex items-center gap-2 mt-2">
            <input
              type="checkbox"
              className="h-5 w-5 accent-main_color dark:bg-dark-secondary rounded-md  bg-gray-100 border-gray-300 dark:bg-gray-700 dark:border-gray-600"
              checked={isMainDefault}
              onChange={(e) => setIsMainDefault(e.target.checked)}
            />
            <span className="text-small3 text-gray-600 dark:text-[#737373]">
              {tComponent("location.set_default_location")}
            </span>
          </label>

          <div className="flex mt-[25px] cursor-pointer items-center justify-end">
            <div className="flex justify-center items-center">
              {darkMode ? <TrashIconDark /> : <TrashIcon />}
              <p className="ps-1.5 pt-1 text-small3_b text-body_copy1_color dark:text-color_v1_dark">
                {tComponent("location.delete_cap")}
              </p>
            </div>

            <ExtraSmallFilledButton
              name={`${tComponent("location.save_cap")}`}
              buttonType="submit"
              classes={"ms-3"}
            />
          </div>
        </form>
      </div>
    </I18nextProvider>
  );
};

export default AddLocationForm;
